import { Col, Flex, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import Layout from '@/components/layout/Layout';
import PageWrapper from '@/components/layout/PageWrapper';
import { SubsectionHeading } from '@/UI/typography';

const PrivacyPolicy = () => {
  const [t] = useTranslation();
  const sections = [
    {
      title: 'PRIVACY_TITLE_1',
      texts: ['PRIVACY_TEXT_1', 'PRIVACY_TEXT_1_1', 'PRIVACY_TEXT_1_2'],
    },
    { title: 'PRIVACY_TITLE_2', texts: ['PRIVACY_TEXT_2'] },
    {
      title: 'PRIVACY_TITLE_3',
      texts: [
        'PRIVACY_TEXT_3_1',
        'PRIVACY_TEXT_3_2',
        'PRIVACY_TEXT_3_3',
        'PRIVACY_TEXT_3_4',
        'PRIVACY_TEXT_3_5',
      ],
    },
    {
      title: 'PRIVACY_TITLE_4',
      texts: ['PRIVACY_TEXT_4_1', 'PRIVACY_TEXT_4_2'],
    },
    { title: 'PRIVACY_TITLE_5', texts: ['PRIVACY_TEXT_5'] },
    {
      title: 'PRIVACY_TITLE_6',
      texts: ['PRIVACY_TEXT_6_1', 'PRIVACY_TEXT_6_2'],
    },
    { title: 'PRIVACY_TITLE_7', texts: ['PRIVACY_TEXT_7'] },
    {
      title: 'PRIVACY_TITLE_8',
      texts: ['PRIVACY_TEXT_8_1', 'PRIVACY_TEXT_8_2'],
    },
    { title: 'PRIVACY_TITLE_9', texts: ['PRIVACY_TEXT_9'] },
    { title: 'PRIVACY_TITLE_10', texts: ['PRIVACY_TEXT_10'] },
  ];

  return (
    <Layout>
      <PageWrapper title={t('PRIVACY_POLICY')}>
        <Row justify="center">
          <Col xs={24} md={16} lg={12}>
            <Flex vertical gap="middle">
              {sections.map((section) => (
                <Flex vertical gap="small" key={section.title}>
                  <SubsectionHeading>{t(section.title)}</SubsectionHeading>
                  {section.texts.map((textKey) => (
                    <Typography.Text key={textKey}>
                      {t(textKey)}
                    </Typography.Text>
                  ))}
                </Flex>
              ))}
            </Flex>
          </Col>
        </Row>
      </PageWrapper>
    </Layout>
  );
};

export default PrivacyPolicy;
